import { render, staticRenderFns } from "./PointCardScreen.vue?vue&type=template&id=d226a018&scoped=true&"
import script from "./PointCardScreen.vue?vue&type=script&lang=js&"
export * from "./PointCardScreen.vue?vue&type=script&lang=js&"
import style0 from "./PointCardScreen.vue?vue&type=style&index=0&id=d226a018&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d226a018",
  null
  
)

export default component.exports